import React, { useState } from "react";
import { connect, ConnectedProps } from "react-redux";
import { closeDialog, editNote } from "../../../store/actions";

interface IProps {
  note: string;
  type: string;
}

const mapDispatchToProps = (dispatch: any) => ({
  closeDialogDispatch: () => dispatch(closeDialog()),
  editNoteDispatch: (type: string, note: string) => dispatch(editNote(type, note))
});

const connector = connect(null, mapDispatchToProps);

const EditNote = ({
  note,
  type,
  closeDialogDispatch,
  editNoteDispatch
}: IProps & ConnectedProps<typeof connector>) => {
  const [editedNote, setEditedNote] = useState<string>(note || "");

  return (<>
    <div className={"dialog-content"}>
      <table className="table">
        <tr>
          <td className={"no-border"}>Write the note up to 50 characters</td>
        </tr>
        <tr>
          <td className={"no-border"}>
            <textarea
              className={"textarea"}
              value={editedNote}
              maxLength={50}
              cols={35}
              rows={3}
              onChange={e => setEditedNote(e.target.value)}
            />
          </td>
        </tr>
      </table>
    </div>
    <div className={"dialog-footer"}>
      <a
        href="#"
        onClick={() => closeDialogDispatch()}
        className="btn btn-blank btn-no-width"
      >
        Cancel
      </a>
      <button
        onClick={() => {
          editNoteDispatch(type, editedNote);
          closeDialogDispatch()
        }}
        className="btn btn-blank btn-no-width"
      >
        Save
      </button>
    </div>
  </>)
}

export default connector(EditNote);
